module.exports = __webpack_public_path__ + "static/media/Logo__Chevron.b247d6aa.svg";